import { Table as AntTable } from 'antd';
import { useNavigate } from 'react-router-dom';
import { LoadingIcon } from '@/components/loading';

const Table = ({ loading, pageInfo, ...props }) => {
  const navigate = useNavigate();

  const onChangePage = (page) => {
    const params = new URLSearchParams(window.location.search);
    params.set('page', page);
    navigate(`.?${params.toString()}`);
  };

  return (
    <AntTable
      pagination={
        pageInfo?.count > pageInfo?.pageSize
          ? {
              size: 'small',
              showQuickJumper: true,
              showSizeChanger: false,
              total: pageInfo.count,
              pageSize: pageInfo.pageSize,
              current: pageInfo.pageNumber,
              onChange: onChangePage,
              showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            }
          : {
              showQuickJumper: true,
              showSizeChanger: false,
              total: pageInfo?.count,
              pageSize: pageInfo?.count, // Display all items on one page
              showTotal: (total) => `${total} items`,
            }
      }
      size="middle"
      {...props}
      loading={loading && { indicator: <LoadingIcon /> }}
      style={{ overflowX: 'scroll' }}
    />
  );
};

export default Table;
